<template>
  <div @click.self="viewGroup(groupData.id)" :class="{'panel-link': link}" class="panel panel-list">
    <div class="icon">
      <font-awesome-icon icon="users" />
    </div>
    <div class="content">
      <h4>{{ groupData.groupName }}</h4>
      <p>{{ usersInGroup(groupData.users) }} users</p>
    </div>
    <div class="panel-actions">
      <b-dropdown right class="extra-actions" no-caret>
        <template v-slot:button-content>
          <font-awesome-icon icon="ellipsis-v" />
        </template>
        <li>
          <router-link
            class="dropdown-item"
            :to="{ name: 'group', params: { groupData: groupData } }"
            >Edit group settings</router-link
          >
        </li>
        <li>
          <router-link
            class="dropdown-item"
            :to="'/view/?group=' + groupData.id"
            >View group</router-link
          >
        </li>
<!--         <li>
          <router-link
            class="dropdown-item"
            :to="'/report/?group=' + groupData.id"
            >View group report</router-link
          >
        </li> -->
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupPanel",
  components: {},
  props: {
    groupData: Object,
    link: Boolean,
  },
  data() {
    return {};
  },
  mounted: function() {},
  methods: {
    viewGroup(id) {
      if (this.link) {
        this.$router.push({
          path: "/view/?group=" + id,
        });
      }
    },
    usersInGroup(users) {
      if (users) {
        return users.length;
      } else {
        return 0;
      }
    },
  },
};
</script>
